<template>
  <v-navigation-drawer v-model="show" temporary fixed width="600">
    <filters />
  </v-navigation-drawer>
</template>
<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import { EventBus } from '@/services/event-bus';

export default {
  name: 'DepositFilters',
  computed: {
    ...mapGetters({
      filters: 'deposits/filter',
    }),
  },
  mounted() {},
  components: {
    Filters: () => import('./filters/Main.vue'),
  },
  created() {
    EventBus.$on('layout.deposits.filters.show:true', () => {
      this.show = true;
    });
    EventBus.$on('layout.deposits.filters.show:false', () => {
      this.show = false;
    });
    
  },
  data: () => ({
    show: false,
  }),
};

</script>
